import Inspect from '@/service/inspect'
import RequestUtils from './requestUtils.js'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getinspectreports(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Inspect.getinspectreports(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getinspectreport(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Inspect.getinspectreport(payload), {
        type: 'info',
        success,
        fail
      })
    },
    addinspectreport(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Inspect.addinspectreport(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updateinspectreport(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Inspect.updateinspectreport(payload), {
        type: 'action',
        success,
        fail
      })
    },
    deleteinspectreport(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Inspect.deleteinspectreport(payload), {
        type: 'action',
        success,
        fail
      })
    },
    recallinspectreport(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Inspect.recallinspectreport(payload), {
        type: 'action',
        success,
        fail
      })
    },
    applyauditinspectreport(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Inspect.applyauditinspectreport(payload), {
        type: 'action',
        success,
        fail
      })
    },
    cancelauditinspectreport(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Inspect.cancelauditinspectreport(payload), {
        type: 'action',
        success,
        fail
      })
    },
    auditinspectreport(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Inspect.auditinspectreport(payload), {
        type: 'action',
        success,
        fail
      })
    }
  }
}
